import React from "react";
import './header.css'
export default function Navbar() {
  return (
    <>
      <div className="responsive-container">
        <img src="https://res.cloudinary.com/dhjdvfk3t/image/upload/v1721801018/banner_bfmvnc.png" alt="logo" className="responsive-image" />
      </div>
    </>
  );
}
